<div class="help-page">
  <div class="help-card hero">
    <span class="badge">{{ versaoAtual }}</span>
    <h1>PeritoDesk — Versão do sistema</h1>
    <p>Resumo da versão instalada e das últimas melhorias aplicadas.</p>
  </div>

  <div class="help-card">
    <h2>Alterações principais</h2>
    <ul>
      <li *ngFor="let item of itens">{{ item }}</li>
    </ul>
  </div>

  <div class="help-card">
    <h2>Orientação de uso</h2>
    <p>Use esta página para conferir rapidamente qual pacote está em uso antes de testar uma nova substituição de diretório.</p>
  </div>
</div>

<!-- v91.4.23 VPS Docker Demo -->
